/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  UpdateErrorType,
  ValidationErrorEnum
} from '../../../pages/Orders/LongSteelOrders/OrdersTabs/Tables/OpenOrdersTable/UpdateOrder';
import { EMeasureUnit } from '../../commomTypes';
import { ICustomer } from '../customers/types';
import { EOrderTab } from '../long-steel-orders/types';
import { IMeasureUnit } from '../long-steel-shopping-cart/types';

// Action Types
export enum Types {
  LOAD_NEW_LONG_STEEL_ORDERS_FROM_LOCAL_STORAGE = 'orders/LOAD_NEW_LONG_STEEL_ORDERS_FROM_LOCAL_STORAGE',
  CLEAR_NEW_ORDERS_STATE = 'orders/CLEAR_NEW_ORDERS_STATE',

  LOAD_NEW_LONG_STEEL_ORDERS = 'orders/LOAD_NEW_LONG_STEEL_ORDERS',
  LOAD_NEW_LONG_STEEL_ORDERS_SUCCESS = 'orders/LOAD_NEW_LONG_STEEL_ORDERS_SUCCESS',
  LOAD_NEW_LONG_STEEL_ORDERS_FAILURE = 'orders/LOAD_NEW_LONG_STEEL_ORDERS_FAILURE',

  LOAD_NEW_LONG_STEEL_ORDER_DETAIL = 'orders/LOAD_NEW_LONG_STEEL_ORDER_DETAIL',
  LOAD_NEW_LONG_STEEL_ORDER_DETAIL_SUCCESS = 'orders/LOAD_NEW_LONG_STEEL_ORDER_DETAIL_SUCCESS',
  LOAD_NEW_LONG_STEEL_ORDER_DETAIL_FAILURE = 'orders/LOAD_NEW_LONG_STEEL_ORDER_DETAIL_FAILURE',

  LOAD_NEW_TRACKING_FLAT_STEEL = 'orders/LOAD_NEW_TRACKING_FLAT_STEEL',
  LOAD_NEW_TRACKING_FLAT_STEEL_SUCCESS = 'orders/LOAD_NEW_TRACKING_FLAT_STEEL_SUCCESS',
  LOAD_NEW_TRACKING_FLAT_STEEL_FAILURE = 'orders/LOAD_NEW_TRACKING_FLAT_STEEL_FAILURE',

  LOAD_NEW_TRACKING_LONG_STEEL = 'orders/LOAD_NEW_TRACKING_LONG_STEEL',
  LOAD_NEW_TRACKING_LONG_STEEL_SUCCESS = 'orders/LOAD_NEW_TRACKING_LONG_STEEL_SUCCESS',
  LOAD_NEW_TRACKING_LONG_STEEL_FAILURE = 'orders/LOAD_NEW_TRACKING_LONG_STEEL_FAILURE',

  LOAD_NEW_BILLED_ORDER_TRACKING = 'orders/LOAD_NEW_BILLED_ORDER_TRACKING',
  LOAD_NEW_BILLED_ORDER_TRACKING_SUCCESS = 'orders/LOAD_NEW_BILLED_ORDER_TRACKING_SUCCESS',
  LOAD_NEW_BILLED_ORDER_TRACKING_FAILURE = 'orders/LOAD_NEW_BILLED_ORDER_TRACKING_FAILURE',

  LOAD_NEW_QC_FILE = 'orders/LOAD_NEW_QC_FILE',
  LOAD_NEW_QC_FILE_SUCCESS = 'orders/LOAD_NEW_QC_FILE_SUCCESS',
  LOAD_NEW_QC_FILE_FAILURE = 'orders/LOAD_NEW_QC_FILE_FAILURE',
  DOWNLOAD_NEW_QC_FILE = 'orders/DOWNLOAD_NEW_QC_FILE',

  LOAD_NEW_NF_FILE = 'orders/LOAD_NEW_NF_FILE',
  LOAD_NEW_NF_FILE_SUCCESS = 'orders/LOAD_NEW_NF_FILE_SUCCESS',
  LOAD_NEW_NF_FILE_FAILURE = 'orders/LOAD_NEW_NF_FILE_FAILURE',
  DOWNLOAD_NEW_NF_FILE = 'orders/DOWNLOAD_NEW_NF_FILE',

  LOAD_NEW_SHIPPING_NOTE_FILE = 'orders/LOAD_NEW_SHIPPING_NOTE_FILE',
  LOAD_NEW_SHIPPING_NOTE_FILE_SUCCESS = 'orders/LOAD_NEW_SHIPPING_NOTE_FILE_SUCCESS',
  LOAD_NEW_SHIPPING_NOTE_FILE_FAILURE = 'orders/LOAD_NEW_SHIPPING_NOTE_FILE_FAILURE',
  DOWNLOAD_NEW_SHIPPING_NOTE_FILE = 'orders/DOWNLOAD_NEW_SHIPPING_NOTE_FILE',

  CG_NEW_QC_FILE_REQUEST = 'orders/CG_NEW_QC_FILE_REQUEST',
  CG_NEW_QC_FILE_REQUEST_SUCCESS = 'orders/CG_NEW_QC_FILE_REQUEST_SUCCESS',
  CG_NEW_QC_FILE_REQUEST_FAILURE = 'orders/CG_NEW_QC_FILE_REQUEST_FAILURE',
  CG_NEW_QC_FILE_DOWNLOAD = 'orders/CG_NEW_QC_FILE_DOWNLOAD',

  LOAD_UPDATE_ITEMS = 'orders/LOAD_UPDATE_ITEMS',
  LOAD_UPDATE_ITEMS_SUCCESS = 'orders/LOAD_UPDATE_ITEMS_SUCCESS',
  LOAD_UPDATE_ITEMS_FAILURE = 'orders/LOAD_UPDATE_ITEMS_FAILURE',

  VALIDATION_UPDATE_ITEMS = 'orders/VALIDATION_UPDATE_ITEMS',
  VALIDATION_UPDATE_ITEMS_SUCCESS = 'orders/VALIDATION_UPDATE_ITEMS_SUCCESS',
  VALIDATION_UPDATE_ITEMS_FAILURE = 'orders/VALIDATION_UPDATE_ITEMS_FAILURE',

  LOAD_OPTIONS_UPDATE_ITEMS = 'orders/LOAD_OPTIONS_UPDATE_ITEMS',
  LOAD_OPTIONS_UPDATE_ITEMS_SUCCESS = 'orders/LOAD_OPTIONS_UPDATE_ITEMS_SUCCESS',
  LOAD_OPTIONS_UPDATE_ITEMS_FAILURE = 'orders/LOAD_OPTIONS_UPDATE_ITEMS_FAILURE',

  LOAD_XML = 'orders/LOAD_XML',
  LOAD_XML_SUCCESS = 'orders/LOAD_XML_SUCCESS',
  LOAD_XML_FAILURE = 'orders/LOAD_XML_FAILURE',

  DOWNLOAD_WALLET = 'orders/DOWNLOAD_WALLET',
  UPDATE_FILTERED_ORDERS = 'orders/UPDATE_FILTERED_ORDERS',
  DOWNLOADS_ITEMS = 'orders/DOWNLOADS_ITEMS',
  REPEAT_ORDERS = 'orders/REPEAT_ORDERS',

  UPADTE_TABLE_TYPE = 'orders/UPDATE_TABLE_TYPE'
}

export enum ELongSteelOrdersStatus {
  ALL = 'all',
  PENDING = 'pending', // Saldo
  DELIVERY = 'delivery', // Em remessa
  SHIPMENT = 'shipment', // Em carregamento
  BILLED = 'billed', // Faturado
  CANCELLED = 'cancelled' // Cancelado
}

export enum EOpenColumn {
  ORDER_NUMBER = '0',
  OV_GERDAU = '1'
}

export enum EMaterialOpenColumn {
  GERDAU_MATERIAL = '0',
  CLIENT_MATERIAL = '1'
}

export interface INewLongSteelOrdersState {
  loading: boolean;
  tableType: EOrderTab;
  error: boolean;

  open: ITabOrderDataState;
  billed: ITabOrderDataState;

  updateItems: IUpdateItems;

  receivers?: ICustomer[];
  emitters?: ICustomer[];
  states?: string[];
  divisions: IOrderDivision[];
  bpError?: boolean;
}

export interface ITabOrderDataState {
  items: SalesOrderItem[];
  ordersFiltered?: SalesOrderItemTable[];
  initialInputValues: IOrdersInitialInputValues;
  lastLoadTime?: number;
  initialized: boolean;
  orderDetail: SalesOrderItem[];
}

export interface INewLongSteelOrdersResponse {
  receivers?: ICustomer[];
  emitters?: ICustomer[];
  divisions: IOrderDivision[];
  bpError?: boolean;
  updateItems: IUpdateItems;

  items: SalesOrderItem[];
  lastLoadTime?: number;
  initialInputValues: IOrdersInitialInputValues;
  orderDetail: SalesOrderItem[];
  ordersFiltered?: SalesOrderItemTable[];
  orderType?: EOrderTab;
  minOrderDate?: string;
  maxOrderDate?: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IOrdersCustomResponse {
  // mantem se necessário ou usa INewLongSteelOrdersResponse
}

export interface IUpdateItems {
  itemsSelected: SalesOrderItem[];
  itemsToUpdate: IUpdateOrderRequest[];
  itemsAllowed: SalesOrderItem[];
  cancelMessage?: string;
  downloadsItemsSelected?: SalesOrderItemTableData[];
  typeAction?: ITypeActionKey;
  loading: {
    cancelOrders: boolean;
    exportOrders: boolean;
    downloadOrders: boolean;
    repeatOrders: boolean;
    validationOrders: boolean;
  };
}

export interface IOrdersInitialInputValues {
  states: string[];
  emitterIds: string[];
  receiverId: string;
  receiverBilledId?: string;
  orderStatus: ELongSteelOrdersStatus;
  startDate?: string;
  endDate?: string;
}

export interface IOrderDivision {
  division: string;
  divisionDescription: string;
}
export interface INewLongSteelOrderData {
  id: string;
  shipTo: ILongSteelOrderCustomer;
  soldTo: ILongSteelOrderCustomer;
}

export enum EOrderType {
  PLANOS = 'Planos',
  LONGOS = 'Longos'
}

export interface ILongSteelOrderCustomer {
  address: string;
  city: string;
  code: string;
  country: string;
  name: string;
  neighborhood: string;
  state: string;
  taxNumber: string;
  zipCode: string;
}

// EM ABERTO
export interface IOpenOrderData extends INewLongSteelOrderData, IOrderDivision {
  salesOrder: number;
  customerOrder: string;
  customerOrderItem: string;
  customerSKU: string;
  itemCancelledDate: string;
  itemCreationDate: string;
  requestedDate: string;
  materialDescription: string;
  orderType: EOrderType;
  plant: string;
  plantDescription: string;
  sku: number;
  salesOrderItem: number;
  status: string;
  futureDeliveries: IFutureDelivery[];

  salesOrg: string;

  conditions: IOpenOrderConditions;
  quantities: IOpenOrderQuantities;
  trackingFlatSteel?: ITrackingFlatSteelState;
  trackingFlatsteelExcel: ITrackingFlatSteel;

  trackingLongSteel?: ITrackingLongSteelState;
}

interface ITrackingLongSteelState {
  loading: boolean;
  error: boolean;
  longSteel?: ITrackingLongSteel;
}

export interface ITrackingLongSteel {
  billing: {
    billingQuantity: string;
    measureUnit: EMeasureUnit;
    tracking: ITrackingLongSteelItemData[];
  };
  deliveries: {
    deliveryQuantity: string;
    measureUnit: EMeasureUnit;
    tracking: ITrackingLongSteelItemData[];
  };
  shipments: {
    shipmentQuantity: string;
    measureUnit: EMeasureUnit;
    tracking: ITrackingLongSteelItemData[];
  };
}
export interface ITrackingLongSteelItemData {
  date: string;
  measureUnit: EMeasureUnit;
  quantity: string;
}

export interface IFutureDelivery {
  estimatedDeliveryDate: string;
  estimatedDeliveryMeasureUnit: EMeasureUnit;
  estimatedDeliveryQuantity: string;
}

interface ITrackingFlatSteelState {
  loading: boolean;
  error: boolean;
  flatsteel?: ITrackingFlatSteel;
}

export interface ITrackingFlatSteel {
  openQuantity: number; //Saldo da Ordem
  meltShop: number; //Aciaria
  rollingMill: number; //Laminação
  rollingFinish: number; //LA
  finish: number; //Acabamento
  stockMill: number; //Estoque Usina
  transit: number; //Em Transferência
  stockWarehouse: number; //Estoque Entre-Posto

  billedPercentual: string;
  billedQuantity: number;
  checkDate: number;
  clientOrderNumber: string;
  confirmedDate: string;
  fillRateDate: string;
  itemDescription: string;
  itemNumber: string;
  orderStatus: string;
  orderType: string;
  percentageOpen: number;
  port: number;
  productionAlert: string;
  requestedDate: string;
  requestedQuantity: number;
  requestedQuantityUnitMeasure: string;
  salesOrder: string;
  shipment: number;
  toleranceType: string;
  transportDoc: number;
  unitMeasure: string;
}

interface IOpenOrderConditions {
  aliquotIcms: string;
  icms: string;
  ipi: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  st: string;
  totalValueWithTaxes: string;
  totalValueWithoutIpi: string;
  totalValueWithoutTaxes: string;
  unitPriceWithTaxes: string;
  unitPriceWithTaxesUnit: string;
  unitPriceWithoutTaxes: string;
  unitPriceWithoutTaxesUnit: string;
  unitPriceCustomerFlatSteel: string;
}

export interface IOpenOrderQuantities {
  billedConversionQuantity: string;
  billedMeasureUnit: EMeasureUnit;
  billedQuantity: string;
  deliveryConversionQuantity: string;
  deliveryDate: string;
  deliveryMeasureUnit: EMeasureUnit;
  deliveryQuantity: string;
  pendingConversionQuantity: string;
  pendingMeasureUnit: EMeasureUnit;
  pendingQuantity: string;
  requestedConversionQuantity: string;
  requestedMeasureUnit: EMeasureUnit;
  requestedQuantity: string;
  shipmentConversionQuantity: string;
  shipmentMeasureUnit: EMeasureUnit;
  shipmentQuantity: string;
}

// FATURADOS
export interface IBilledOrderData extends INewLongSteelOrderData {
  billingNumber: string;
  cqNumber: string;
  danfeNumber: string;
  deliveryCode: string;
  deliveryDocumentZvoi: string;
  deliveryItemCode: string;
  invoiceNumber: string;
  invoiceZvoi: string;
  itemBillingDate: string;
  nfeAccessKey: string;
  productionBatch: string;
  dueDate: string[];
  billing: {
    customerOrder: string;
    customerSKU: string;
    division: string;
    divisionDescription: string;
    itemCreationDate: string;
    loteAdminSKU: string;
    materialDescription: string;
    orderType: string;
    plant: string;
    plantDescription: string;
    salesOrder: number;
    salesOrderItem: number;
    sku: number;
    salesOrganization: string;
    statusQC?: CgCertificateStatus;

    billingNumber: string;
    cqNumber: string;
    danfeNumber: string;
    deliveryCode: string;
    deliveryDocumentZvoi: string;
    deliveryItemCode: string;
    invoiceZvoi: string;
    nfeAccessKey: string;
    productionBatch: string;
    itemBillingDate: string;
  };

  quantities: IBilledOrderQuantities;
  conditions: IBilledOrderConditions;

  trackingState: IBilledOrderTrackingState;
  qcState: IQCColumnState;
  nfState: INFEColumnState;
  shippingNoteState?: IShippingNoteColumnState;
}

export enum CgCertificateStatus {
  Available = 'available',
  Processing = 'processing',
  NotFound = 'not-found',
  Ready = 'ready',
  Error = 'error',
  ErrorMail = 'error-mail'
}

export interface ICgCertificateRequest {
  sku: string;
  code: string;
  plant: string;
  deliveryCode: string;
  deliveryItemCode: string;
  invoiceNumber: string;
  salesOrder: string;
  salesOrderItem: string;
  statusQC: CgCertificateStatus;
  product: string;
  productionBatch: string;
}

export interface ICgCertificateResponse {
  ok: boolean;
  content: [
    {
      status: CgCertificateStatus;
      order_id: string;
      filename?: string;
      buffer?: string;
    }
  ];
}

interface IBilledOrderTrackingState {
  loading: boolean;
  error: boolean;
  tracking?: IBilledOrderTracking;
}
export interface IBilledOrderTracking {
  accessKey: string;
  billedDate: string;
  customerCity: string;
  customerName: string;
  customerPurchaseOrder: string;
  customerTaxNumber: string;
  deliveryDate: string;
  estimateDate: string;
  gerdauTaxNumber: string;
  invoice: string;
  plantCity: string;
  plantName: string;
  transportStatus: string;

  transportData: [
    {
      carrierName: string;
      carrierTaxNumber: string;
      loadingDate: string;
      loadingEndDate: string;
      loadingStatus: string;
      modalType: string;
    }
  ];

  transportLog: [
    {
      createdDate: string;
      receiver: {
        name: string;
        type: string;
      };
      transportType: 'entrada' | 'saida';
    }
  ];
}

interface IBilledOrderQuantities {
  billedConversionQuantity: number;
  billingMeasureUnit: EMeasureUnit;
  billingQuantity: number;
  requestedConversionQuantity: number;
  requestedMeasureUnit: EMeasureUnit;
  requestedQuantity: number;
}

export interface IBilledOrderConditions {
  invoiceItemValueWithTaxes: string;
  invoiceItemValueWithoutTaxes: string;
  invoiceTotalValueWithTaxes: string;
  invoiceTotalValueWithoutTaxes: string;
  invoiceVolume: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  salesTotalValueWithTaxes: string;
  unitPriceWithoutTaxes: string;
  unitPriceWithoutTaxesUnit: string;
}

export interface IDownloadNFEResponse {
  FILE: string;
  XML: string;
}

export interface IQCFileResponse {
  qcFile: {
    files: {
      cqId: string;
      deliveryItemNumber: string;
      status: 'SUCCESS' | 'FAILED';
    }[];
    qcBase64File: string;
  };
}

export interface IQCColumnState {
  canDownloadQC: boolean;
  qcFileResponse?: IQCFileResponse;
  // Essa tipagem mudará quando aceitarmos download em batch
  cgQcCertificateResponse?: ICgCertificateResponse['content'][0];
  loading?: boolean;
  error?: boolean;
  alreadyDownloaded?: boolean;
}

export interface INFEColumnState {
  canDownloadNF: boolean;
  downloadNFEResponse?: IDownloadNFEResponse;
  loading?: boolean;
  error?: boolean;
  alreadyDownloaded?: boolean;
}

export interface IShippingNoteColumnState {
  downloadNFEResponse?: IDownloadNFEResponse;
  loading?: boolean;
  error?: boolean;
  alreadyDownloaded?: boolean;
}

export interface ordersType {
  [index: string]: string;
}

export interface IUpdateOrderValidation {
  customer: string;
  orderId: string;
}

export interface IUpdateOrderValidationResponse {
  orderId: string;
  sku: string;
  soldTo: string;
  shipTo: string;
  changeAllowed: boolean;
  reasonNotAllowed?: ValidationErrorEnum;
}

export interface IOrdersChangeData {
  soldTo: string;
  shipTo: string;
  details: [
    {
      gerdauSku: string;
      clientSku?: string | null;
      skuQuantity?: string | null;
      skuMeasureUnity?: string | null;
      desiredDate?: string | null;
      customerPurchaseItem?: string | null;
    }
  ];
}

export interface IOrdersChageDataResponse {
  sku: string;
  measureUnits: IMeasureUnit[];
}

export interface IUpdateOrderRequest {
  customer: string;
  customerType: 'soldTo'; // atualmente só se pode fazer a alteração de pedido para RECEBEDOR
  salesOrder: string;
  salesOrderItem: string;
  quantity?: string; //newVolume
  unityMeasure?: EMeasureUnit;
  requiredDate?: string;
  status?: 'cancelado';
  reasonMessage?: string;
  editMessage?: string;
}

export interface IUpdateOrderResponse {
  salesOrder: string;
  salesOrderItem: string;
  requestEditStatus: 'processando' | 'rejeitado' | 'não processado';
  errors: IUpdateOrderResponseError[];
}

export interface IUpdateOrderResponseError {
  attribute: UpdateErrorType;
  errorMessage: string;
}

export enum EModalMessageErrorType {
  SHIPMENT = 'remessa',
  SPECIAL = 'especial',
  PROCCESS = 'processo'
}

export interface IOpenOrdersTableDataSource {
  key: string;
  id: string;
  sku: string;
  materialDescription: string;
  customerOrder: string;
  customerSKU: string;
  creationDate: string;
  requestedDate: string;
  creationDateTable: string;
  requestedDateTable: string;
  quantities: IOpenOrderQuantities;
  productState: IOpenOrderQuantities;
  numberOrder: string;
  emitter: string;
  receiver: string;
  salesOrder: string;
  salesOrderItem: string;
  divisionDescription: string;
  orderType: EOrderType;
  totalQuantityConfirmed: string;
  totalQuantityRequested: string;
  totalQuantityBilled: string;
  totalQuantityPending: string;
  totalQuantityDelivery: string;
  totalQuantityShipment: string;
  meltShop: string;
  rollingMill: string;
  rollingFinish: string;
  finish: string;
  stockMill: string;
  transit: string;
  stockWarehouse: string;
  futureDeliveries: IFutureDelivery[];
  futureDeliveriesTable: string;
  item: IOpenOrderData;
  soldTo: ILongSteelOrderCustomer;
  shipTo: ILongSteelOrderCustomer;
  futureDeliveriesDate: string;
  futureDeliveriesQuantity: string;
  futureDeliveriesUnit: string;
  [key: string]: any;
}
interface Quantities {
  measureUnit: EMeasureUnit;
  requestedQuantity: string;
  billingMeasureUnit: string;
  requestedConversionQuantity: string;
  requestedMeasureUnit: EMeasureUnit;
  pendingQuantity: string;
  pendingConversionQuantity: string;
  pendingMeasureUnit: EMeasureUnit;
  deliveryQuantity: string;
  deliveryConversionQuantity: string;
  deliveryMeasureUnit: EMeasureUnit;
  deliveryDate: string;
  shipmentQuantity: string;
  shipmentConversionQuantity: string;
  shipmentMeasureUnit: EMeasureUnit;
  // billed
  billedQuantity: string;
  billedConversionQuantity: string;
  billedMeasureUnit: EMeasureUnit;
}

export interface Conditions {
  aliquotIcms: string;
  icms: string;
  ipi: string;
  st: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  totalValueWithTaxes: string;
  totalValueWithoutTaxes: string;
  totalValueWithoutIpi: string;
  unitPriceWithoutTaxes: string;
  unitPriceWithoutTaxesUnit: EMeasureUnit;
  unitPriceWithTaxes: string;
  unitPriceWithTaxesUnit: EMeasureUnit;
  unitPriceCustomerFlatSteel: string;
  // billed
  invoiceItemValueWithTaxes: string;
  invoiceItemValueWithoutTaxes: string;
  invoiceTotalValueWithTaxes: string;
  invoiceTotalValueWithoutTaxes: string;
  invoiceVolume: string;

  // Novas informações
  totalOrderNT: string;
  totalOrderWTaxes: string;
  totalOrderSt: string;
  totalOrderIcms: string;
  totalOrderPis: string;
  totalOrderIpi: string;
  totalorderCofins: string;
  itemPis: string;
  itemCofins: string;
}

export interface FutureDelivery {
  estimatedDeliveryDate: string;
  estimatedDeliveryQuantity: string;
  estimatedDeliveryMeasureUnit: EMeasureUnit;
}

export interface Billing {
  cqNumber: string;
  itemBillingDate: string;
  billingNumber: string;
  danfeNumber: string;
  invoiceNumber: string;
  deliveryCode: string;
  deliveryItemCode: string;
  productionBatch: string;
  deliveryDocumentZvoi: string;
  invoiceZvoi: string;
  nfeAccessKey: string;
  loteAdminSKU: string;
  statusQC: CgCertificateStatus;
  paymentTerms: string;
  paymentTermsDescription: string;
  billedQuantity: number;
  billedConversionQuantity: number;
  canDownloadQC?: boolean;
  canDownloadNF?: boolean;
  unitPriceWithoutTaxes: string;
  unitPriceWithoutTaxesUnit: string;
  invoiceItemValueWithoutTaxes: string;
  invoiceTotalValueWithTaxes: string;
  invoiceTotalValueWithoutTaxes: string;
  invoiceItemValueWithTaxes: string;
}

export interface SalesOrderItem {
  dueDate: string[];
  id: string;
  fiscalBenefit: string;
  salesOrder: string;
  salesOrderItem: string;
  customerOrder: string;
  customerOrderItem: string;
  salesOrg: string;
  division: string;
  divisionDescription: string;
  plantDescription: string;
  itemCreationDate: string;
  requestedDate: string;
  sku: string;
  materialDescription: string;
  customerSKU: string;
  orderType: string;
  soldTo: ILongSteelOrderCustomer;
  shipTo: ILongSteelOrderCustomer;
  quantities: Quantities;
  conditions: Conditions;
  futureDeliveries?: FutureDelivery[];
  billing: Billing[];
  invoices?: Billing[];
  billingNumber?: string;
  danfeNumber?: string;
  cqNumber?: string;
  deliveryCode?: string;
  deliveryItemCode?: string;
  productionBatch?: string;
  deliveryDocumentZvoi?: string;
  invoiceZvoi?: string;
  nfeAccessKey?: string;
  billingHistory: {
    customerOrder: string;
    customerSKU: string;
    division: string;
    divisionDescription: string;
    itemCreationDate: string;
    loteAdminSKU: string;
    materialDescription: string;
    orderType: string;
    plant: string;
    plantDescription: string;
    salesOrder: number;
    salesOrderItem: number;
    sku: number;
    salesOrganization: string;
    statusQC?: CgCertificateStatus;
    canDownloadQC?: boolean;
    canDownloadNF?: boolean;
    qcState?: IQCColumnState;
    nfState?: INFEColumnState;
  };
  qcState: IQCColumnState;
  nfState: INFEColumnState;
  trackingFlatSteel?: ITrackingFlatSteelState;
  flatSteelProduction?: ITrackingFlatSteel;
  trackingFlatsteelExcel: ITrackingFlatSteel;

  trackingLongSteel?: ITrackingLongSteelState;
  shippingNoteState?: IShippingNoteColumnState;
  trackingState: IBilledOrderTrackingState;
  changeAllowed?: boolean;
  measureUnits?: IMeasureUnit[];
  plant: string;
  destination: string;
}

export interface SalesOrderItemTableData extends SalesOrderItem {
  key: string;
  emitter: string;
  productState: Quantities;
  numberOrder: string;
  creationDate: string;
  creationDateTable: string;
  requestedDateTable: string;
  receiver: string;
  totalQuantityConfirmed: string;
  totalQuantityRequested: string;
  totalQuantityBilled: string;
  totalQuantityPending: string;
  totalQuantityDelivery: string;
  totalQuantityShipment: string;
  meltShop: string | number;
  rollingMill: string | number;
  rollingFinish: string | number;
  finish: string | number;
  stockMill: string | number;
  transit: string | number;
  stockWarehouse: string | number;
  dueDate: string[];

  futureDeliveriesTable: string;
  [key: string]: any;
  item: SalesOrderItem;
}

export type SalesOrderItemTable = SalesOrderItemTableData &
  Partial<SalesOrderItem>;

export type Filters = Partial<
  Omit<
    SalesOrderItemTable,
    'quantities' | 'productState' | 'futureDeliveries' | 'item'
  >
>;

export const INITIAL_FILTERS: Filters = {
  customerOrder: '',
  sku: '',
  customerSKU: '',
  materialDescription: '',
  creationDateTable: '',
  requestedDateTable: '',
  creationDate: '',
  requestedDate: '',
  futureDeliveriesTable: '',
  emitter: '',
  receiver: '',
  salesOrder: '',
  numberOrder: '',
  salesOrderItem: '',
  divisionDescription: '',
  totalQuantityRequested: '',
  totalQuantityConfirmed: '',
  totalQuantityPending: '',
  totalQuantityDelivery: '',
  totalQuantityShipment: '',
  totalQuantityBilled: '',
  meltShop: '',
  rollingMill: '',
  rollingFinish: '',
  finish: '',
  stockMill: '',
  transit: '',
  stockWarehouse: ''
};

export const INITIAL_RESUME_DETAILS = {
  creationDate: '',
  totalQuantityRequested: 0,
  totalQuantityPending: 0,
  totalQuantityBilled: 0,
  totalValueWithTaxes: '',
  totalValueWithoutTaxes: '',
  icms: '',
  pis: '',
  cofins: '',
  ipi: '',
  iss: '',
  st: '',
  fcp: '',
  difal: '',
  soldTo: {
    name: '',
    taxNumber: '',
    address: '',
    country: '',
    city: '',
    zipCode: '',
    code: ''
  },
  shipTo: {
    name: '',
    taxNumber: '',
    address: '',
    country: '',
    city: '',
    zipCode: '',
    code: ''
  },
  requestedMeasure: '',
  quantities: {
    billed: {
      quantity: 0,
      measureUnit: ''
    },
    delivery: {
      quantity: 0,
      measureUnit: ''
    },
    shipment: {
      quantity: 0,
      measureUnit: ''
    },
    pending: {
      quantity: 0,
      measureUnit: ''
    },
    requested: {
      quantity: 0,
      measureUnit: ''
    }
  }
};

export type ITypeActionKey =
  | 'cancel'
  | 'update'
  | 'repeatOrder'
  | 'downloads'
  | 'validation';

export const typeActionDicionary: Record<ITypeActionKey, string> = {
  update: 'Solicitar alterações',
  cancel: 'Solicitar cancelamento',
  downloads: 'Download',
  repeatOrder: 'Repetir pedido',
  validation: 'Validação'
};

export const ALLOWED_STATUS = [
  'Aguardando confirmação',
  'Dentro do prazo',
  'Com atraso',
  'Em atraso'
] as const;

export type StatusType = (typeof ALLOWED_STATUS)[number];

export const statusVariantMap: Record<
  StatusType,
  'info' | 'primary' | 'success' | 'warning'
> = {
  'Aguardando confirmação': 'info',
  'Dentro do prazo': 'info',
  'Com atraso': 'warning',
  'Em atraso': 'warning'
};

export interface IXMLResponse {
  FILE: string;
  XML: string;
}
